import './Dot.scss'

export interface DotProps {
  /** Diameter of the circle in px. Default 3 (Figma node 3628:5189). */
  size?: number
  /** Outer container size in px. Default 5. */
  containerSize?: number
  className?: string
}

/**
 * Minimal circular separator dot. The outer span is a 5×5 container, the
 * inner circle is 3px — matching Figma node 3628:5189. Inherits colour via
 * `currentColor`; callers set `color` on a surrounding element (or via
 * `className`) to tint it.
 *
 * @example
 * <span style={{ color: 'var(--muted-foreground)' }}>
 *   Label <Dot /> Meta
 * </span>
 */
export function Dot({ size = 3, containerSize = 5, className }: DotProps) {
  const classes = ['dot', className].filter(Boolean).join(' ')
  return (
    <span
      aria-hidden="true"
      className={classes}
      style={{ width: containerSize, height: containerSize }}
    >
      <span className="dot__inner" style={{ width: size, height: size }} />
    </span>
  )
}
